import request from '@/utils/request'

export function getLoginUserMenu () {
  return request({
    url: '/admin/sysMenu/v1/router',
    method: 'get'
  })
}

export function listMenu(query) {
  return request({
    url: '/admin/sysMenu/v1/findByPage',
    method: 'post',
    data: Object.assign({}, query, {page:1, pageSize: 10000})
  })
}

export function grantList() {
  return request({
    url: '/admin/sysMenu/v1/grantList',
    method: 'get'
  })
}


export function addObj(obj) {
  return request({
    url: '/admin/sysMenu/v1/createSysMenu',
    method: 'post',
    data: obj
  })
}

export function delObj(id) {
  return request({
    url: '/admin/sysMenu/v1/deleteById/' + id,
    method: 'post'
  })
}

export function putObj(obj) {
  return request({
    url: '/admin/sysMenu/v1/updateSysMenu',
    method: 'post',
    data: obj
  })
}
